import React from 'react';
import { Container } from 'react-bootstrap';
import { AuthProvider } from 'contexts/authContext';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PrivateRoute from 'privateRoute';


import Login from './Login';
import ForgotPassword from './ForgotPassword'
import HomeS from 'HomeS';
import Signup from './Signup';
import Fpage from './viewsS/Fpage';

import Dashboard from './viewsS/Dashboard';
import AddPost from 'viewsS/AddPost';
import ApproveAcc from 'viewsS/ApproveAcc';
import TMDetails from 'viewsS/TMDetails';
import UserApprove from 'viewsS/UserApprove';
import userLocations from 'viewsS/userLocations';
import ActivateRewards from 'viewsS/ActivateRewards';
import UpdateAccDetails from 'viewsS/UpdateAccDetails';

function AppS() {
  return (
    <>

      <Router>
      <AuthProvider>
  
      <Switch>

        <PrivateRoute path='/HomeS' exact component={HomeS} />
        <Route path='/' exact component={Fpage} />
        <Route path='/signup' component={Signup} />
        <Route path='/login' component={Login} />
        <Route path='/forgot-password' component={ForgotPassword} />
        <Route path='/dashboard' component={Dashboard} />
        <Route path='/AddPost' component={AddPost} /> 
        <Route path='/ApproveAcc' component={ApproveAcc} />
        <Route path='/TMDetails' component={TMDetails} />
        <Route path='/UserApprove' component={UserApprove} />
        <Route path='/userLocations' component={userLocations} />
        <Route path='/ActivateRewards/:UserName' component={ActivateRewards} /> 
        <Route path='/UpdateAccDetails/:id' component={UpdateAccDetails} /> 

        </Switch>
        </AuthProvider>
      </Router>
    </>
  );
}

export default AppS;

